module.exports = __webpack_public_path__ + "img/17_12.3cba39ea.png";